import React, { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';

// responsiveFrontendMobileFixedButtonsWhereSearchAlreadyExistOnPage webpackChunkName koristiti samo unutar entry na
// kojem SearchForm već postoji, u protivnom će Webpack značajno povećati veličinu ovog importa time što će mu dodati
// SearchForm, a to bi povećalo značajno output dev 759kB vs 3600kB.
const MobileFixedButtons = lazy(() => import(/* webpackChunkName: "responsiveFrontendMobileFixedButtonsWhereSearchAlreadyExistOnPage" */ '@PROJECT_ROOT/assets/responsive-frontend/js/search/searchDock'));

// NE KORISTITI OSIM NA stranicama Home i Search - kako bi Webpack odsekao drugo učitavanje koda za SearchForm
export default function initMobileFixedButtonsWhereSearchAlreadyExistOnPage() {
    let isInitialized = false;
    let isScheduled = false;
    function loadSearchDock() {
        if (isInitialized || window.innerWidth >= 991) return;
        const mobileFixedButtons = document.getElementById('mobileFixedButtonsReact');
        if (!mobileFixedButtons) return;
        isInitialized = true;
        window.searchDockInitialized = true;
        const root = createRoot(mobileFixedButtons);
        root.render(
            <Suspense fallback="">
                <MobileFixedButtons />
            </Suspense>,
        );
    }

    function scheduleSearchDock() {
        if (isInitialized || isScheduled || window.searchDockInitialized || window.innerWidth >= 991) return;
        isScheduled = true;
        const load = () => {
            isScheduled = false;
            if (window.innerWidth < 991) {
                loadSearchDock();
            }
        };

        if ('requestIdleCallback' in window) {
            // TODO: Povecao bih do 1.5 - provjerit sa Tihanom.
            window.requestIdleCallback(load, { timeout: 500 });
        } else {
            setTimeout(load, 800);
        }
    }

    scheduleSearchDock();

    window.addEventListener('resize', () => {
        if (window.innerWidth < 991 && !isInitialized && !window.searchDockInitialized) {
            scheduleSearchDock();
        }
    });
}
